import Vue from 'vue'
import { toRefs } from '@vue/composition-api'




const state = Vue.observable({
  drawer: false,
  title: null,
  show(test) {
    console.log('test', test)
  },
})

function setTitle(title) {
  state.title = title
  document.title = title
}



export default function useApp() {


  return {
    ...toRefs(state),
    setTitle,
  }

}




